import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from './cn';

/** Tạo dãy số trang gọn có dấu "…". */
function pageRange(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('…');
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < total - 1) pages.push('…');
  pages.push(total);
  return pages;
}

const ITEM =
  'inline-flex items-center justify-center min-w-9 h-9 px-2 text-sm font-medium border border-line-strong bg-surface-sunken text-body transition-colors -ml-px first:ml-0 first:rounded-l-lg last:rounded-r-lg hover:bg-surface hover:text-heading focus:outline-none focus-visible:z-10 focus-visible:ring-2 focus-visible:ring-indigo-500/40 disabled:opacity-50 disabled:cursor-not-allowed';

/** Pagination — page, pageCount, onChange(page). */
export function Pagination({ page = 1, pageCount = 1, onChange, className }) {
  if (pageCount <= 1) return null;
  const pages = pageRange(page, pageCount);
  return (
    <nav className={cn('inline-flex', className)} aria-label="Phân trang">
      <button
        type="button"
        className={cn(ITEM, 'rounded-l-lg')}
        onClick={() => onChange?.(Math.max(1, page - 1))}
        disabled={page <= 1}
        aria-label="Trang trước"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>
      {pages.map((p, i) =>
        p === '…' ? (
          <span key={`gap-${i}`} className={cn(ITEM, 'cursor-default hover:bg-surface-sunken')}>
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange?.(p)}
            aria-current={p === page ? 'page' : undefined}
            className={cn(ITEM, p === page && 'bg-surface text-brand-fg font-semibold')}
          >
            {p}
          </button>
        )
      )}
      <button
        type="button"
        className={cn(ITEM, 'rounded-r-lg')}
        onClick={() => onChange?.(Math.min(pageCount, page + 1))}
        disabled={page >= pageCount}
        aria-label="Trang sau"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </nav>
  );
}

export default Pagination;
